<template>
    <div>
        <div style="max-height: 45vh; overflow-y: auto; overflow-x: hidden">
            <v-row>
                <v-col>
                    <h4>Facture</h4>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field-filled
                        v-model="chrono.invoiceChrono"
                        label="Chrono des factures"
                        :error="isInvoiceChronoError"
                        :error-messages="invoiceChronoError"
                        hide-details="auto"
                        outlined
                        :readonly="isInvoiceDisabled"
                        density="compact"
                    />
                </v-col>
                <v-col cols="12" class="pl-6"> Exemple: {{ invoiceChronoExample }} </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-select-filled
                        label="Rêgle de réinitialisation du compteur des factures"
                        v-model="chrono.invoiceResetCounterCondition"
                        :items="resetCounterConditions"
                        item-value="value"
                        hide-details
                        outlined
                        :readonly="isInvoiceDisabled"
                        density="compact"
                        :item-title="(item) => item.title"
                    >
                    </v-select-filled>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <h4>Devis</h4>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field-filled
                        v-model="chrono.quoteChrono"
                        label="Chrono des devis"
                        :error="isQuoteChronoError"
                        :error-messages="quoteChronoError"
                        hide-details="auto"
                        outlined
                        :readonly="isQuoteDisabled"
                        density="compact"
                    />
                </v-col>
                <v-col cols="12" class="pl-6"> Exemple: {{ quoteChronoExample }} </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-select-filled
                        label="Rêgle de réinitialisation du compteur des devis"
                        v-model="chrono.quoteResetCounterCondition"
                        :items="resetCounterConditions"
                        item-value="value"
                        hide-details
                        outlined
                        :readonly="isQuoteDisabled"
                        density="compact"
                        :item-title="(item) => item.title"
                    >
                    </v-select-filled>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <h4>Bon de livraison</h4>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field-filled
                        v-model="chrono.deliveryBillChrono"
                        label="Chrono des bon de livraison"
                        :error="isDeliveryBillChronoError"
                        :error-messages="deliveryBillChronoError"
                        hide-details="auto"
                        outlined
                        :readonly="isDeliveryBillDisabled"
                        density="compact"
                    />
                </v-col>
                <v-col cols="12" class="pl-6"> Exemple: {{ deliveryBillChronoExample }} </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-select-filled
                        label="Rêgle de réinitialisation du compteur des bon de livraisons"
                        v-model="chrono.deliveryBillResetCounterCondition"
                        :items="resetCounterConditions"
                        item-value="value"
                        hide-details
                        outlined
                        :readonly="isDeliveryBillDisabled"
                        density="compact"
                        :item-title="(item) => item.title"
                    >
                    </v-select-filled>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <h4>Avoir</h4>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field-filled
                        v-model="chrono.creditNoteChrono"
                        label="Chrono des avoirs"
                        :error="isCreditNoteChronoError"
                        :error-messages="creditNoteChronoError"
                        hide-details="auto"
                        outlined
                        :readonly="isCreditNoteDisabled"
                        density="compact"
                    />
                </v-col>
                <v-col cols="12" class="pl-6"> Exemple: {{ creditNoteChronoExample }} </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-select-filled
                        label="Rêgle de réinitialisation du compteur des avoirs"
                        v-model="chrono.creditNoteResetCounterCondition"
                        :items="resetCounterConditions"
                        item-value="value"
                        hide-details
                        outlined
                        :readonly="isCreditNoteDisabled"
                        density="compact"
                        :item-title="(item) => item.title"
                    >
                    </v-select-filled>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <h4>Acompte</h4>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field-filled
                        v-model="chrono.depositChrono"
                        label="Chrono des acomptes"
                        :error="isDepositChronoError"
                        :error-messages="depositChronoError"
                        hide-details="auto"
                        outlined
                        :readonly="isDepositDisabled"
                        density="compact"
                    />
                </v-col>
                <v-col cols="12" class="pl-6"> Exemple: {{ depositChronoExample }} </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-select-filled
                        label="Rêgle de réinitialisation du compteur des acomptes"
                        v-model="chrono.depositResetCounterCondition"
                        :items="resetCounterConditions"
                        item-value="value"
                        hide-details
                        outlined
                        :readonly="isDepositDisabled"
                        density="compact"
                        :item-title="(item) => item.title"
                    >
                    </v-select-filled>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script lang="ts">
import { invoiceChrono } from "@/types/invoiceAdvanceSettings.types";
import moment from "moment-timezone";

import GET_COMPANY_LAST_INVOICE_VALIDATED from "@/graphql/company/GetCompanyLastInvoiceValidated.gql";
import GET_COMPANY_LAST_DEPOSIT_VALIDATED from "@/graphql/company/GetCompanyLastDepositValidated.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class InvoiceChronoSetting extends Vue {
    @Prop() chrono: invoiceChrono;
    @Prop({ default: "" }) companyId: string;

    resetCounterConditions = [
        { title: "Aucun", value: "NONE" },
        { title: "Mensuelle", value: "MONTH" },
        { title: "Annuelle", value: "YEAR" },
    ];

    isInvoiceDisabled = false;
    isQuoteDisabled = false;
    isDeliveryBillDisabled = false;
    isCreditNoteDisabled = false;
    isDepositDisabled = false;

    get isInvoiceChronoError() {
        let regex = /(X+)/;
        switch (this.chrono.invoiceResetCounterCondition) {
            case "DAY":
                regex = /(?=.*DD)(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                break;
            case "MONTH":
                regex = /(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                break;
            case "YEAR":
                regex = /(?=.*(?:YY|YYYY))(?=.*X).+/;
        }
        const match = regex.test(this.chrono.invoiceChrono);
        if (!match) {
            return true;
        }
        if (
            this.chrono.invoiceChrono === this.chrono.quoteChrono ||
            this.chrono.invoiceChrono === this.chrono.deliveryBillChrono ||
            this.chrono.invoiceChrono === this.chrono.creditNoteChrono ||
            this.chrono.invoiceChrono === this.chrono.depositChrono
        ) {
            return true;
        }
        return false;
    }

    get invoiceChronoError() {
        let regex = /(X+)/;
        let matchError = "Vous devez renseigner obligatoirement le compteur de factures";
        switch (this.chrono.invoiceResetCounterCondition) {
            case "DAY":
                regex = /(?=.*DD)(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                matchError =
                    "Le chrono des factures doit contenir un espace pour les compteurs, les jours, les mois et les années";
                break;
            case "MOUNTH":
                regex = /(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                matchError =
                    'Vous devez renseigner obligatoirement le compteur de factures, l\'année au format long "YYYY" et le mois au format "MM"';
                break;
            case "YEAR":
                regex = /(?=.*(?:YY|YYYY))(?=.*X).+/;
                matchError =
                    'Vous devez renseigner obligatoirement le compteur de factures et l\'année au format long "YYYY"';
                break;
        }
        const match = regex.test(this.chrono.invoiceChrono);
        if (!match) {
            this.chrono.error.invoiceChrono = matchError;
            return this.chrono.error.invoiceChrono;
        }
        if (this.chrono.invoiceChrono === this.chrono.quoteChrono) {
            this.chrono.error.invoiceChrono =
                "Le chrono des factures et celui des devis doivent être différent";
            return this.chrono.error.invoiceChrono;
        } else if (this.chrono.invoiceChrono === this.chrono.deliveryBillChrono) {
            this.chrono.error.invoiceChrono =
                "Le chrono des factures et celui des bon de livraison doivent être différent";
            return this.chrono.error.invoiceChrono;
        } else if (this.chrono.invoiceChrono === this.chrono.creditNoteChrono) {
            this.chrono.error.invoiceChrono =
                "Le chrono des factures et celui des avoirs doivent être différent";
            return this.chrono.error.invoiceChrono;
        } else if (this.chrono.invoiceChrono === this.chrono.depositChrono) {
            this.chrono.error.invoiceChrono =
                "Le chrono des factures et celui des acomptes doivent être différent";
            return this.chrono.error.invoiceChrono;
        }
        this.chrono.error.invoiceChrono = "";
        return this.chrono.error.invoiceChrono;
    }

    get isQuoteChronoError() {
        let regex = /(X+)/;
        switch (this.chrono.quoteResetCounterCondition) {
            case "DAY":
                regex = /(?=.*DD)(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                break;
            case "MOUNTH":
                regex = /(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                break;
            case "YEAR":
                regex = /(?=.*(?:YY|YYYY))(?=.*X).+/;
        }
        const match = regex.test(this.chrono.quoteChrono);
        if (!match) {
            return true;
        }
        if (
            this.chrono.quoteChrono === this.chrono.invoiceChrono ||
            this.chrono.quoteChrono === this.chrono.deliveryBillChrono ||
            this.chrono.quoteChrono === this.chrono.creditNoteChrono ||
            this.chrono.quoteChrono === this.chrono.depositChrono
        ) {
            return true;
        }
        return false;
    }

    get quoteChronoError() {
        let regex = /(X+)/;
        let matchError = "Vous devez renseigner obligatoirement le compteur de devis";
        switch (this.chrono.quoteResetCounterCondition) {
            case "DAY":
                regex = /(?=.*DD)(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                matchError =
                    "Le chrono des devis doit contenir un espace pour les compteurs, les jours, les mois et les années";
                break;
            case "MOUNTH":
                regex = /(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                matchError =
                    'Vous devez renseigner obligatoirement le compteur de devis, l\'année au format long "YYYY" et le mois au format "MM"';
                break;
            case "YEAR":
                regex = /(?=.*(?:YY|YYYY))(?=.*X).+/;
                matchError =
                    'Vous devez renseigner obligatoirement le compteur de devis et l\'année au format long "YYYY"';
                break;
        }
        const match = regex.test(this.chrono.quoteChrono);
        if (!match) {
            this.chrono.error.quoteChrono = matchError;
            return this.chrono.error.quoteChrono;
        }
        if (this.chrono.quoteChrono === this.chrono.invoiceChrono) {
            this.chrono.error.quoteChrono =
                "Le chrono des devis et celui des factures doivent être différent";
            return this.chrono.error.quoteChrono;
        } else if (this.chrono.quoteChrono === this.chrono.deliveryBillChrono) {
            this.chrono.error.quoteChrono =
                "Le chrono des devis et celui des bon de livraison doivent être différent";
            return this.chrono.error.quoteChrono;
        } else if (this.chrono.quoteChrono === this.chrono.creditNoteChrono) {
            this.chrono.error.quoteChrono =
                "Le chrono des devis et celui des avoirs doivent être différent";
            return this.chrono.error.quoteChrono;
        } else if (this.chrono.quoteChrono === this.chrono.depositChrono) {
            this.chrono.error.quoteChrono =
                "Le chrono des devis et celui des acomptes doivent être différent";
            return this.chrono.error.quoteChrono;
        }
        this.chrono.error.quoteChrono = "";
        return this.chrono.error.quoteChrono;
    }

    get isDeliveryBillChronoError() {
        let regex = /(X+)/;
        switch (this.chrono.deliveryBillResetCounterCondition) {
            case "DAY":
                regex = /(?=.*DD)(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                break;
            case "MOUNTH":
                regex = /(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                break;
            case "YEAR":
                regex = /(?=.*(?:YY|YYYY))(?=.*X).+/;
        }
        const match = regex.test(this.chrono.deliveryBillChrono);
        if (!match) {
            return true;
        }
        if (
            this.chrono.deliveryBillChrono === this.chrono.invoiceChrono ||
            this.chrono.deliveryBillChrono === this.chrono.quoteChrono ||
            this.chrono.deliveryBillChrono === this.chrono.creditNoteChrono ||
            this.chrono.deliveryBillChrono === this.chrono.depositChrono
        ) {
            return true;
        }
        return false;
    }

    get deliveryBillChronoError() {
        let regex = /(X+)/;
        let matchError = "Vous devez renseigner obligatoirement le compteur de bon de livraison";
        switch (this.chrono.deliveryBillResetCounterCondition) {
            case "DAY":
                regex = /(?=.*DD)(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                matchError =
                    "Le chrono des bon de livraisons doit contenir un espace pour les compteurs, les jours, les mois et les années";
                break;
            case "MOUNTH":
                regex = /(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                matchError =
                    'Vous devez renseigner obligatoirement le compteur de bon de livraison, l\'année au format long "YYYY" et le mois au format "MM"';
                break;
            case "YEAR":
                regex = /(?=.*(?:YY|YYYY))(?=.*X).+/;
                matchError =
                    'Vous devez renseigner obligatoirement le compteur de bon de livraison et l\'année au format long "YYYY"';
                break;
        }
        const match = regex.test(this.chrono.deliveryBillChrono);
        if (!match) {
            this.chrono.error.deliveryBillChrono = matchError;
            return this.chrono.error.deliveryBillChrono;
        }
        if (this.chrono.deliveryBillChrono === this.chrono.invoiceChrono) {
            this.chrono.error.deliveryBillChrono =
                "Le chrono des bon de livraison et celui des factures doivent être différent";
            return this.chrono.error.deliveryBillChrono;
        } else if (this.chrono.deliveryBillChrono === this.chrono.quoteChrono) {
            this.chrono.error.deliveryBillChrono =
                "Le chrono des bon de livraison et celui des devis doivent être différent";
            return this.chrono.error.deliveryBillChrono;
        } else if (this.chrono.deliveryBillChrono === this.chrono.creditNoteChrono) {
            this.chrono.error.deliveryBillChrono =
                "Le chrono des bon de livraison et celui des avoirs doivent être différent";
            return this.chrono.error.deliveryBillChrono;
        } else if (this.chrono.deliveryBillChrono === this.chrono.depositChrono) {
            this.chrono.error.deliveryBillChrono =
                "Le chrono des bon de livraison et celui des acomptes doivent être différent";
            return this.chrono.error.deliveryBillChrono;
        }
        this.chrono.error.deliveryBillChrono = "";
        return this.chrono.error.deliveryBillChrono;
    }

    get isCreditNoteChronoError() {
        let regex = /(X+)/;
        switch (this.chrono.creditNoteResetCounterCondition) {
            case "DAY":
                regex = /(?=.*DD)(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                break;
            case "MOUNTH":
                regex = /(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                break;
            case "YEAR":
                regex = /(?=.*(?:YY|YYYY))(?=.*X).+/;
        }
        const match = regex.test(this.chrono.creditNoteChrono);
        if (!match) {
            return true;
        }
        if (
            this.chrono.creditNoteChrono === this.chrono.invoiceChrono ||
            this.chrono.creditNoteChrono === this.chrono.quoteChrono ||
            this.chrono.creditNoteChrono === this.chrono.deliveryBillChrono ||
            this.chrono.creditNoteChrono === this.chrono.depositChrono
        ) {
            return true;
        }
        return false;
    }

    get creditNoteChronoError() {
        let regex = /(X+)/;
        let matchError = "Vous devez renseigner obligatoirement le compteur de avoirs";
        switch (this.chrono.creditNoteResetCounterCondition) {
            case "DAY":
                regex = /(?=.*DD)(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                matchError =
                    "Le chrono des avoirs doit contenir un espace pour les compteurs, les jours, les mois et les années";
                break;
            case "MOUNTH":
                regex = /(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                matchError =
                    'Vous devez renseigner obligatoirement le compteur de avoirs, l\'année au format long "YYYY" et le mois au format "MM"';
                break;
            case "YEAR":
                regex = /(?=.*(?:YY|YYYY))(?=.*X).+/;
                matchError =
                    'Vous devez renseigner obligatoirement le compteur de avoirs et l\'année au format long "YYYY"';
                break;
        }
        const match = regex.test(this.chrono.creditNoteChrono);
        if (!match) {
            this.chrono.error.creditNoteChrono = matchError;
            return this.chrono.error.creditNoteChrono;
        }
        if (this.chrono.creditNoteChrono === this.chrono.invoiceChrono) {
            this.chrono.error.creditNoteChrono =
                "Le chrono des avoirs et celui des factures doivent être différent";
            return this.chrono.error.creditNoteChrono;
        } else if (this.chrono.creditNoteChrono === this.chrono.quoteChrono) {
            this.chrono.error.creditNoteChrono =
                "Le chrono des avoirs et celui des devis doivent être différent";
            return this.chrono.error.creditNoteChrono;
        } else if (this.chrono.creditNoteChrono === this.chrono.deliveryBillChrono) {
            this.chrono.error.creditNoteChrono =
                "Le chrono des avoirs et celui des bon de livraison doivent être différent";
            return this.chrono.error.creditNoteChrono;
        } else if (this.chrono.creditNoteChrono === this.chrono.depositChrono) {
            this.chrono.error.creditNoteChrono =
                "Le chrono des avoirs et celui des acomptes doivent être différent";
            return this.chrono.error.creditNoteChrono;
        }
        this.chrono.error.creditNoteChrono = "";
        return this.chrono.error.creditNoteChrono;
    }

    get isDepositChronoError() {
        let regex = /(X+)/;
        switch (this.chrono.depositResetCounterCondition) {
            case "DAY":
                regex = /(?=.*DD)(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                break;
            case "MOUNTH":
                regex = /(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                break;
            case "YEAR":
                regex = /(?=.*(?:YY|YYYY))(?=.*X).+/;
        }
        const match = regex.test(this.chrono.depositChrono);
        if (!match) {
            return true;
        }
        if (
            this.chrono.depositChrono === this.chrono.invoiceChrono ||
            this.chrono.depositChrono === this.chrono.quoteChrono ||
            this.chrono.depositChrono === this.chrono.deliveryBillChrono ||
            this.chrono.depositChrono === this.chrono.creditNoteChrono
        ) {
            return true;
        }
        return false;
    }

    get depositChronoError() {
        let regex = /(X+)/;
        let matchError = "Vous devez renseigner obligatoirement le compteur de acomptes";
        switch (this.chrono.depositResetCounterCondition) {
            case "DAY":
                regex = /(?=.*DD)(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                matchError =
                    "Le chrono des acomptes doit contenir un espace pour les compteurs, les jours, les mois et les années";
                break;
            case "MOUNTH":
                regex = /(?=.*(?:YY|YYYY))(?=.*X)(?=.*MM).+/;
                matchError =
                    'Vous devez renseigner obligatoirement le compteur de acomptes, l\'année au format long "YYYY" et le mois au format "MM"';
                break;
            case "YEAR":
                regex = /(?=.*(?:YY|YYYY))(?=.*X).+/;
                matchError =
                    'Vous devez renseigner obligatoirement le compteur de acomptes et l\'année au format long "YYYY"';
                break;
        }
        const match = regex.test(this.chrono.depositChrono);
        if (!match) {
            this.chrono.error.depositChrono = matchError;
            return this.chrono.error.depositChrono;
        }
        if (this.chrono.depositChrono === this.chrono.invoiceChrono) {
            this.chrono.error.depositChrono =
                "Le chrono des acomptes et celui des factures doivent être différent";
            return this.chrono.error.depositChrono;
        } else if (this.chrono.depositChrono === this.chrono.quoteChrono) {
            this.chrono.error.depositChrono =
                "Le chrono des acomptes et celui des devis doivent être différent";
            return this.chrono.error.depositChrono;
        } else if (this.chrono.depositChrono === this.chrono.deliveryBillChrono) {
            this.chrono.error.depositChrono =
                "Le chrono des acomptes et celui des bon de livraison doivent être différent";
            return this.chrono.error.depositChrono;
        } else if (this.chrono.depositChrono === this.chrono.creditNoteChrono) {
            this.chrono.error.depositChrono =
                "Le chrono des acomptes et celui des avoirs doivent être différent";
            return this.chrono.error.depositChrono;
        }
        this.chrono.error.depositChrono = "";
        return this.chrono.error.depositChrono;
    }

    chronoExample(chrono) {
        const date = moment(new Date());
        const mounth = date.format("MM");
        const fullYear = date.format("YYYY");
        const year = date.format("YY");
        const day = date.format("DD");
        const regex: RegExp = /(X+)/;
        const match = chrono.match(regex);
        const counter = 1;
        let numberZero;

        if (match.length) {
            numberZero = match.at(0).length;
        }

        chrono = chrono.replaceAll("YYYY", fullYear);
        chrono = chrono.replaceAll("YY", year);
        chrono = chrono.replaceAll("MM", mounth);
        chrono = chrono.replaceAll("DD", day);
        chrono = chrono.replaceAll(match.at(0), counter.toString(10).padStart(numberZero, "0"));
        return chrono;
    }

    get invoiceChronoExample() {
        return this.chronoExample(this.chrono.invoiceChrono);
    }

    get quoteChronoExample() {
        return this.chronoExample(this.chrono.quoteChrono);
    }

    get deliveryBillChronoExample() {
        return this.chronoExample(this.chrono.deliveryBillChrono);
    }

    get creditNoteChronoExample() {
        return this.chronoExample(this.chrono.creditNoteChrono);
    }

    get depositChronoExample() {
        return this.chronoExample(this.chrono.depositChrono);
    }

    async beforeMount() {
        const invoices = await this.$apollo.query({
            query: GET_COMPANY_LAST_INVOICE_VALIDATED,
            variables: {
                companyId: this.companyId ? this.companyId : this.$store.state.selected_company.id,
                type: "INVOICE",
            },
        });
        const quotes = await this.$apollo.query({
            query: GET_COMPANY_LAST_INVOICE_VALIDATED,
            variables: {
                companyId: this.companyId ? this.companyId : this.$store.state.selected_company.id,
                type: "QUOTATION",
            },
        });
        const deliveryBills = await this.$apollo.query({
            query: GET_COMPANY_LAST_INVOICE_VALIDATED,
            variables: {
                companyId: this.companyId ? this.companyId : this.$store.state.selected_company.id,
                type: "BILL_DELIVERY",
            },
        });
        const creditNotes = await this.$apollo.query({
            query: GET_COMPANY_LAST_INVOICE_VALIDATED,
            variables: {
                companyId: this.companyId ? this.companyId : this.$store.state.selected_company.id,
                type: "CREDIT_NOTE",
            },
        });
        const deposits = await this.$apollo.query({
            query: GET_COMPANY_LAST_DEPOSIT_VALIDATED,
            variables: {
                companyId: this.companyId ? this.companyId : this.$store.state.selected_company.id,
            },
        });
        if (invoices.data.invoices.length) {
            this.isInvoiceDisabled = true;
        }
        if (quotes.data.invoices.length) {
            this.isQuoteDisabled = true;
        }
        if (deliveryBills.data.invoices.length) {
            this.isDeliveryBillDisabled = true;
        }
        if (creditNotes.data.invoices.length) {
            this.isCreditNoteDisabled = true;
        }
        if (deposits.data.invoices.length) {
            this.isDepositDisabled = true;
        }
    }
}

export default toNative(InvoiceChronoSetting);
</script>
